/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="9.32"
        height="9.69"
        viewBox="0 0 9.32 9.69"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M5.17 9.69V1.9l3.44 3.46.7-.71L4.69 0 0 4.67l.7.7 3.47-3.44v7.76h1z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'ArrowUpIcon';

export default Icon;
